module.exports = __webpack_public_path__ + "img/weibo.0d4ce5d5.png";